import request from 'checkout/utils/axios'

export const updateSummary = async () => {
  const response = await request
    .get('/summary')
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })
  return response
}
